import colorPalette from '../color-palette';

const { primary, secondary, text } = colorPalette;

export default {
  MuiSlider: {
    thumb: {
      height: 24,
      width: 24,
      backgroundColor: 'transparent',
      marginTop: -12,
      marginLeft: -12,
      '&.Mui-disabled': {
        height: 24,
        width: 24,
        backgroundColor: 'transparent',
        marginTop: -12,
        marginLeft: -12,
      },
    },
    valueLabel: {
      left: 'calc(-50% + 9px)',
      top: -22,
      '& *': {
        background: 'transparent',
        color: primary.main,
      },
    },
    track: {
      height: 2,
      backgroundColor: secondary.main,
    },
    rail: {
      height: 2,
      opacity: 0.5,
      backgroundColor: text.slider,
    },
    mark: {
      height: 8,
      width: 8,
      borderRadius: '50%',
      marginTop: -3,
      marginLeft: -4,
      backgroundColor: text.slider,
    },
    markLabel: {
      color: text.slider,
    },
    markLabelActive: {
      color: text.slider,
    },
    markActive: {
      backgroundColor: secondary.main,
    },
  },
};
